export const SUC_SELECT_CHANGED_EVENT = "suc-select-changed-event";
export const SUC_RADIO_CHANGED_EVENT = "suc-radio-changed-event";
export const SUC_DATE_PERIOD_CHANGED_EVENT = "suc-date-period-changed-event";
export const SUC_DATE_PERIOD_SET_DATE_EVENT = "suc-date-period-set-date-event";
export const SUC_PERIOD_CHANGED_EVENT = "suc-period-changed-event";
